import { Formik } from 'formik';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { Department, useDestroyDepartment } from '../../api';
import ButtonField from '../FormFields/ButtonField';

export default function DeleteDepartment(props: {
    deptData: Department[] | undefined;
    refetch: any;
}) {
    const { mutateAsync, isSuccess } = useDestroyDepartment();
    interface DeleteDeptProps {
        id: string;
    }

    const DeleteDeptInitialValues = {
        id: '',
    };

    const handleSubmit = async (values: DeleteDeptProps) => {
        await mutateAsync({ id: values.id.toString() });
        toast.success(`Department Deleted`);
    };

    useEffect(() => {
        if (isSuccess) props.refetch();
    }, [isSuccess, props]);

    return (
        <div className="flex flex-col px-10">
            <h2 className="py-4 border-x-zxblue-from text-transparent font-semibold md:text-xl lg:text-2xl bg-clip-text bg-gradient-to-t from-zxheader-from to-zxheader-to">
                <span className="border-l-2 border-zxsub-to pl-1">
                    Delete Department
                </span>
            </h2>
            <Formik
                initialValues={DeleteDeptInitialValues}
                onSubmit={handleSubmit}
            >
                {({ handleChange, submitForm, resetForm }) => (
                    <form className="flex flex-row space-x-14">
                        <div className="flex flex-col">
                            <label className="pl-0.5 border-zxblue-to">
                                Delete Department
                            </label>
                            <select
                                name="id"
                                id="id"
                                className="w-48 h-8 mb-4 border px-1 py-1 rounded-md focus:outline-none border-zxblue-to text-sm"
                                onChange={handleChange}
                            >
                                <option defaultValue={undefined}>Select</option>
                                {props.deptData?.map(
                                    (deptDetails: Department) => (
                                        <option
                                            key={deptDetails.id}
                                            value={deptDetails.id}
                                        >
                                            {deptDetails.name}
                                        </option>
                                    )
                                )}
                            </select>
                        </div>
                        <ButtonField
                            name="Delete"
                            className="mt-[2%]"
                            onClick={() => {
                                submitForm().then(() => {
                                    resetForm();
                                });
                            }}
                        />
                    </form>
                )}
            </Formik>
        </div>
    );
}
